import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "filter-component" }
const _hoisted_2 = { class: "filter-component__num-input" }

import { ref, onMounted, Ref, watch } from "vue";
import { useFilterStore } from "../../stores/filterStore";
import { IFilter } from "interfaces/filter/IFilter";
import { useFilterState } from "@/services/filter-state-service";


export default /*@__PURE__*/_defineComponent({
  __name: 'IntervalFilter',
  props: {
  title: String,
  dataKey: String
},
  setup(__props) {

const filterStore = useFilterStore();
const { updateFilter } = useFilterState();

const props = __props;

onMounted(() => {
  const existingFilter = filterStore.activeFilters.find(
    (filter: IFilter) => filter.dataKey === props.dataKey);

  if (existingFilter) {
    min.value = existingFilter.value.min;
    max.value = existingFilter.value.max;
  }
});

const min: Ref<number | null | string> = ref(null);
const max: Ref<number | null | string> = ref(null);

function updateIntervalFilter() {
  // We only accept numbers or null values
  const minVal = min.value === '' ? null : min.value;
  const maxVal = max.value === '' ? null : max.value;

  if ((minVal === null || typeof minVal === 'number') && (maxVal === null || typeof maxVal === 'number')) {
    const filter: IFilter = {
      dataKey: props.dataKey ?? '',
      value: {
        min: minVal,
        max: maxVal
      }
    };

    updateFilter(filter);
  }
}

// Reset min and max if all filters are removed
watch(filterStore.activeFilters, (newFilters )=> {
  if (newFilters.length === 0) {
    min.value = null;
    max.value = null;
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", null, _toDisplayString(__props.title), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        type: "number",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((min).value = $event)),
        placeholder: "Min",
        onBlur: _cache[1] || (_cache[1] = ($event: any) => (updateIntervalFilter())),
        onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (updateIntervalFilter()), ["enter"]))
      }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
        [_vModelText, min.value]
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("span", { class: "icon icon--minus" }, null, -1 /* HOISTED */)),
      _withDirectives(_createElementVNode("input", {
        type: "number",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((max).value = $event)),
        placeholder: "Max",
        onBlur: _cache[4] || (_cache[4] = ($event: any) => (updateIntervalFilter())),
        onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (updateIntervalFilter()), ["enter"]))
      }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
        [_vModelText, max.value]
      ])
    ])
  ]))
}
}

})